
import React, { Component } from "react";
import Head from "next/head";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// import TagManager from 'react-gtm-module';
import SeoMeta from '/components/seoMeta';

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }

const styles = theme => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing.unit * 2,
      color: theme.palette.text.secondary,
      [theme.breakpoints.up('sm')]: {
        margin: '50px 0px'
      }
    },
    aboutUsTitle:{
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: 18,
      fontSize: '1.5em'
    },
    aboutUsPara:{
      textIndent: 50
    },
    privacySubTitle:{
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      marginTop: 20
    },
    paraFontWeight:{
        fontWeight: 'bold'
    },
    innityAd: {
        padding : 60,
        textAlign: 'center'
    }
  });

class PrivacyPolicy extends Component {
  constructor(props){
    super(props);
    this.state = {
      ssrDone: false,
    };
  }  

  render() {
    const { classes } = this.props;
    const ssrDone = this.state.ssrDone;  

    return (
      <div>
        <Head>
          <title>Privacy Policy</title>
        </Head>
        <SeoMeta 
            url={`${process.env.BACKEND_URL}/privacy-policy`} 
            type="article"
            title='Privacy Policy'
            description="Privacy Policy"
            image='https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg'
            section='Privacy Policy'
            keywords='Privacy Policy'
          />        
        <NProgress />
        <div className={classes.root}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={12} sm={10} md={8}>
              <Paper className={classes.paper}>
                <Typography component="h2" variant="h5" className={classes.aboutUsTitle} gutterBottom>
                        Privacy Policy
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                        Duwun.com.mm knows that you care about how your personal information is used and shared, and we take your privacy very seriously. Please read the following to learn more about our privacy policy. By visiting our website, you are accepting the practices outlined in this Privacy Policy.
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                        This Privacy Policy covers Duwun.com.mm treatment of personal information that Duwun.com.mm gathers when you are on the Duwun.com.mm website and when you use Duwun.com.mm services. This policy does not apply to the practices of third parties that Duwun.com.mm does not own or control, or to individuals that Duwun.com.mm does not employ or manage.
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.privacySubTitle} gutterBottom>
                        Information Collected by Duwun.com.mm            
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                        We only collect personal information that is relevant to the purpose of our website. This information allows us to provide you with a customized and efficient experience. We do not process this information in a way that is incompatible with this objective. We collect the following types of information from our Duwun.com.mm users:
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                  <span className={classes.paraFontWeight}>Information You Provide to Us:</span> We receive and store any information you enter on our website or provide to us in any other way. You can choose not to provide us with certain information, but then you may not be able to take advantage of many of our special features.        
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                  <span className={classes.paraFontWeight}>Automatic Information:</span>
                        We receive and store certain types of information whenever you interact with us. Duwun.com.mm and its authorized agents automatically receive and record certain traffic data on their server logs from your browser including your IP address, Duwun.com.mm cookie information, and the page you requested. Duwun.com.mm uses this traffic data to help diagnose problems with its servers, analyze trends and administer the website.
                        Duwun.com.mm may collect and, on any page, display the total counts that page has been viewed.
                        Many companies offer programs that help you to visit websites anonymously. While Duwun.com.mm will not be able to provide you with a personalized experience if we cannot recognize you, we want you to be aware that these programs are available.            
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.privacySubTitle} gutterBottom>
                        E-mail Communications           
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                    Duwun.com.mm is very concerned about your privacy and we will never provide your email address to a third party without your explicit permission, as detailed in the “Sharing Your Information” section below. Duwun.com.mm may send out e-mails with Duwun.com.mm - related news, products, offers, surveys or promotions.            
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.privacySubTitle} gutterBottom>
                        Cookies          
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                        Cookies are alphanumeric identifiers that we transfer to your computer is hard drive through your Web browser to enable our systems to recognize your browser and tell us how and when pages in our website are visited and by how many people. Duwun.com.mm cookies do not collect personal information, and we do not combine information collected through cookies with other personal information to tell us who you are or what your screen name or e-mail address is.           
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                    The help portion of the toolbar on the majority of browsers will direct you on how to prevent your browser from accepting new cookies, how to command the browser to tell you when you receive a new cookie, or how to fully disable cookies. We recommend that you leave the cookies activated because cookies allow you to use some of Duwun.com.mm’s coolest features.            
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                    is advertising partners may place a cookie on your browser that makes it possible to collect anonymous non-personally identifiable information that ad delivery systems use to present more relevant ads.  If you would prefer to opt-out of this standard practice, please visit our advertising partner.
                </Typography>

                <Typography component="h2" variant="subtitle1" className={classes.privacySubTitle} gutterBottom>
                    Sharing Your Information         
                </Typography>
                <Typography component="h2" variant="body1" className={classes.aboutUsPara} gutterBottom>
                    Rest assured that we neither rent nor sell your personal information to anyone and that we will share your personal information only as described below.            
                </Typography>
                <Typography component="h2" variant="body1" className={classes.aboutUsPara} gutterBottom>
                  <span className={classes.paraFontWeight}>Duwun.com.mm Personnel:</span> Duwun.com.mm personnel and authorized consultants and/or contractors may have access to user information if necessary in the normal course of Duwun.com.mm business.
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                  <span className={classes.paraFontWeight}>Business Transfers:</span> In some cases, we may choose to buy or sell assets. In these types of transactions, user information is typically one of the business assets that is transferred. Moreover, if Duwun.com.mm, or substantially all of its assets, were acquired, user information would be one of the assets that is transferred.
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                  <span className={classes.paraFontWeight}>Protection of Duwun.com.mm and Others:</span> We may release personal information when we believe in good faith that release is necessary to comply with a law; to enforce or apply our Terms of Use and other policies; or to protect the rights, property, or safety of Duwun.com.mm, our employees, our users, or others. This includes exchanging information with other companies and organizations for fraud protection and credit risk reduction.            
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                  <span className={classes.paraFontWeight}>Syndication:</span> Duwun.com.mm allows for the RSS syndication of all of its public content within the Duwun.com.mm website.            
                </Typography>
                <Typography component="h2" variant="subtitle1" className={classes.aboutUsPara} gutterBottom>
                  <span className={classes.paraFontWeight}>With Your Consent:</span> Except as noted above, we will contact you when your personal information is shared with third parties or used for a purpose incompatible with the purpose(s) for which it was originally collected, and you will be able to opt out to prevent the sharing of this information.          
                </Typography>

                <Typography component="h2" variant="subtitle1" className={classes.privacySubTitle} gutterBottom>
                    Children Under 18 Years of Age      
                </Typography>
                <Typography component="h2" variant="body1" className={classes.aboutUsPara} gutterBottom>
                    You must be 13 years and older to register to use the Duwun.com.mm website. As a result, Duwun.com.mm does not specifically collect information about children. If we learn that Duwun.com.mm has collected information from a child under the age of 13, we will delete that information as quickly as possible. We recommend that minors between the ages of 13 and 18 ask and receive their parents permission before using Duwun.com.mm or sending information about themselves or anyone else over the Internet.            
                </Typography>
                
                <Typography component="h2" variant="subtitle1" className={classes.privacySubTitle} gutterBottom>
                        Changes to this Privacy Policy
                </Typography>
                <Typography component="h2" variant="body1" className={classes.aboutUsPara} gutterBottom>
                    Duwun.com.mm may amend this Privacy Policy from time to time, at its sole discretion. Use of information we collect now is subject to the Privacy Policy in effect at the time such information is used. If we make changes to the Privacy Policy, we will notify you by posting an announcement on the Duwun.com.mm website so you are always aware of what information we collect, how we use it, and under what circumstances if any, it is disclosed.            
                </Typography>
                
                <Typography component="h2" variant="subtitle1" className={classes.privacySubTitle} gutterBottom>
                    Conditions of Use      
                </Typography>
                <Typography component="h2" variant="body1" className={classes.aboutUsPara} gutterBottom>
                    If you decide to visit Duwun.com.mm website, your visit and any possible dispute over privacy is subject to this Privacy Policy and our Terms of Use, including limitations on damages, arbitration of disputes, and application of Myanmar’s laws.           
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
    componentDidMount () {
        this.setState({
            ssrDone: true,
        });
    }

    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)
    }
}
export default withStyles(styles)(PrivacyPolicy);